import { createContext, useContext } from 'react';

const SidebarOpenStateContext = createContext<{
  isSidebarOpen: boolean;
  toggleSidebar: (forceValue?: boolean) => void;
}>({
  isSidebarOpen: false,
  toggleSidebar: () => {},
});

export const useSidebarOpenState = () => useContext(SidebarOpenStateContext);

export default SidebarOpenStateContext;
